<template>
    <div :class="['text-artefact', { editing: isEditing }]">
        <p v-if="!model.content && !isEditing">
            <i>No content.</i>
        </p>
        <RichTextEditor
            v-else
            class="text-editor"
            v-model="model"
            :readingMode="!isEditing"
        />
    </div>
</template>
<script setup lang="ts">
import RichTextEditor from "@/components/RichTextEditor.vue";
import { Artefact } from "@/lib/artefacts";

const model = defineModel<Artefact>({ required: true });
defineProps<{
    isEditing: boolean;
}>();
</script>

<style lang="scss" scoped>
.text-artefact :deep(c-text-editor) {
    &::part(menu-bar) {
        margin-left: calc(var(--default-gap) * -1);
        margin-right: calc(var(--default-gap) * -1);
        overflow: hidden;
    }

    &::part(node-heading-1),
    &::part(node-heading-2) {
        font-weight: normal;
        border-bottom: unset;
    }
}
</style>
